<script>
import Container from "@/Components/Container.vue";
import Card from "primevue/card";
import {useRxSWINSearchPageStore} from "@/stores/pages/rxSWINSearchPage.js";
import {mapStores} from "pinia";

export default {
  name: "Search",
  components: {Container, Card},
  data() {
    return {

    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    searchText: {
      type: String,
    },
  },
  computed: {
    getDetails() {
      return this.details ?? this.$t('common.na');
    },
    ...mapStores(useRxSWINSearchPageStore),
  },
  methods: {
    highlight(item) {
      var check = new RegExp(this.searchText, "ig");
      var word = String(item.regulation.name + "_" + item.identifier);
      return word.toString().replace(check, function(matchedText,a,b){
        return ('<strong class="text-blue-700">' + matchedText + '</strong>');
      });
    },
  },
}
</script>

<template>
  <div class="flex items-center relative justify-center w-full">
    <DataView :value="items" style="" class=" w-full"
              scrollable
              scroll-height="flex"
    >
      <template #list="slotProps">
        <div class="flex flex-col">
          <div v-for="(item, index) in slotProps.items" :key="index">
            <div class="flex flex-col sm:flex-row sm:items-center p-6 gap-4" :class="{ 'border-t border-surface-200 dark:border-surface-700': index !== 0 }">
              <div class="flex grid-cols-4 md:items-center flex-1 gap-6">
                <div class="flex-row md:flex-col justify-between items-start gap-2 shrink-0" style="width:200px">
                  <div>
                    <span data-cy="rxswin-number-display" class="font-medium text-surface-500 dark:text-surface-400 text-medium" v-html="highlight(item)"></span>
                  </div>
                  <Tag :severity="'info'" class="whitespace-nowrap">
                    {{ item?.regulation?.description }}
                  </Tag>
                  <div>
                      <span class="font-semibold text-surface-500 dark:text-surface-400 text-xs">
                        {{ item.vehicle_manufacturer?.name }}
                      </span>
                  </div>
                </div>
                <div class="flex-1 hidden xl:block py-3 text-small font-medium space-x-3 text-center">
                  <span class="text-gray-500 mb-1">
                     {{ $t('pages.rx_swin_search.search.asset_count', { count: item.assets_total ?? 0 }) }}
                  </span>
                </div>
                <div class="flex-1 hidden xl:block items-center py-3 text-medium font-medium space-x-3 text-center">
                  <span class="text-gray-500 mb-1">
                      {{ $t('pages.rx_swin_search.search.hardware_configurations_included', { count: item.mappings_count ?? 0 }) }}
                  </span>
                </div>
                <div class="xl:flex-0 xl:grow-0 flex flex-grow flex-row justify-end">
                  <router-link :to="{name: 'rxswin.search.overview', params: { rxswin: item.id }}">
                    <Button data-cy="view-summary-button" :label="$t('pages.rx_swin_search.search.view_summary')"
                        class="flex-auto md:flex-initial whitespace-nowrap"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </DataView>
  </div>
</template>

<style scoped>

</style>